import { parseDate } from '../utils/formValue';
export default function initDateOnDayOfTheMonthValidator() {

    $.validator.addMethod("dateondayofthemonth",
        function (value, element, params) {
            var date = parseDate(value);

            if (date == null) { return true; } //Continue if not parsed correctly. let date.js handle this

            var validDays = params.validdays.split(",").filter(element => element);
            var validMonths = params.validmonths.split(",").filter(element => element);
            if ((validDays.length === 0 || validDays.includes(date.getDate().toString())) && (validMonths.length === 0 || validMonths.includes((date.getMonth() + 1).toString()))) {
                return true;
            }
            return false;
        })


    $.validator.unobtrusive.adapters.add("dateondayofthemonth", ["validdays", "validmonths", "dateformat"],
        function (options) {
            options.rules['dateondayofthemonth'] =
            {
                validdays: options.params.validdays,
                validmonths: options.params.validmonths,
                dateformat: options.params.dateformat,
            };
            options.messages['dateondayofthemonth'] = options.message;
        }
    );
}